import ContactFormInput, {FormInput} from "./ContactFormInput";
import React from "react";

const ContactInputFormWithLabelAndConditions = ({contactFormInput, remarkInvalidAndEmpty}:{contactFormInput:FormInput, remarkInvalidAndEmpty: boolean}) =>{
    return (
        <div className={"flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-2 w-full text-sm sm:text-base"}>
            <label className={"sm:w-40 font-semibold"}>{contactFormInput.text}</label>
            <div className={"text-black w-full "}>
                <div className={"w-full flex"}>
                    <ContactFormInput contactFormInput={contactFormInput} remarkInvalidAndEmpty={remarkInvalidAndEmpty}/>
                </div>
                <div
                    className={"w-full flex flex-col gap-1 mt-2 items-start text-sm text-mutedLight dark:text-mutedDark"}>
                    {contactFormInput.conditions.map((cond, i) => cond.value &&
                        <div className={"flex gap-1 items-center text-left"} key={i}>{cond.icon}{cond.text}</div>)}
                </div>
            </div>
        </div>
    )
}

export default ContactInputFormWithLabelAndConditions
